/* eslint-disable no-underscore-dangle */
/* global EnableDevTools */

import React from 'react';
import ReactDOM from 'react-dom';
import _ from 'lodash';
import { Provider } from 'react-redux';
import vars from 'vars'; // eslint-disable-line no-unused-vars
import { animateScroll } from 'react-scroll';
import { createStore, applyMiddleware, compose } from 'redux';
import thunk from 'redux-thunk';
import { Router, browserHistory, match } from 'react-router';
import promise from 'redux-promise';
import ES6Promise from 'es6-promise';

import { getRouteScreenUrl } from 'config/routes.helper';
import { removeUnsafeUrlParams } from 'helpers/RouteHelper';
import 'nodelist-foreach'; // IE11 polyfill
import { getUserData } from 'helpers/AuthClientlessHelper';
import { isBrowserIE } from 'helpers/GlobalHelper';
import { disableSmoothScrollMSIE, createProfile, isStaticRender } from 'helpers/ContentHelper';

import reducers from './config/reducers';
import routes from './config/routes-sync';

ES6Promise.polyfill();

let createStoreWithMiddleware;

if (typeof EnableDevTools !== 'undefined' && EnableDevTools) {
  const composeEnhancers =
    typeof window === 'object' && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
      ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({
          trace: true,
          traceLimit: 25,
        })
      : compose;
  createStoreWithMiddleware = composeEnhancers(applyMiddleware(promise, thunk))(createStore);
} else {
  createStoreWithMiddleware = applyMiddleware(promise, thunk)(createStore);
}

function handleUpdate() {
  const { location } = this.state;
  const { action, pathname } = location;
  const isSeason = _.includes(pathname, 'season-');
  const isArticle = pathname?.includes('/article');
  if (action === 'PUSH' && !isSeason) {
    animateScroll.scrollToTop({ duration: 125 });
  }
  if (action === 'POP' && !isArticle) {
    setTimeout(() => {
      window.scrollTo(0, 0);
    }, 3000);
  }
}

function renderPage(store) {
  const container = document.querySelector('.container');
  const provider = (
    <Provider store={store}>
      <Router history={browserHistory} routes={routes} onUpdate={handleUpdate} />
    </Provider>
  );
  const renderMethod = ReactDOM.render;
  renderMethod(provider, container);
}

function renderPageWithDataFetch(store, accessToken) {
  match({ routes, location: window.location }, (err, redirectLocation, renderProps) => {
    // TODO: Should write helper to take in renderProps and output the promise array,
    //   since this is used here and in index-static.js
    const { location, params, history } = renderProps;
    const currentPathname = _.get(location, 'pathname');
    const screenUrl = getRouteScreenUrl(currentPathname);
    const { components } = renderProps;
    const AppComp = components[components.length - 2];
    let Comp = components[components.length - 1];
    if (Comp.WrappedComponent) Comp = Comp.WrappedComponent;
    const appCompFetchData = _.get(AppComp, 'fetchData');
    const compFetchData = _.get(Comp, 'fetchData');
    const fetchNothing = () => Promise.resolve();
    const fetchAppData = appCompFetchData || fetchNothing;
    const fetchData = compFetchData || fetchNothing;
    const fetchParams = { store, location, params, history, screenUrl, accessToken };

    Promise.all([fetchAppData(fetchParams), fetchData(fetchParams)])
      .then(
        () =>
          new Promise(() => {
            renderPage(store);
          }),
      )
      .catch(errFetch => {
        console.log('Error during fetch', errFetch);
        renderPage(store);
      });
  });
}

removeUnsafeUrlParams();

if (typeof document !== 'undefined' && typeof documentFake !== 'boolean') {
  disableSmoothScrollMSIE();
  const store = createStoreWithMiddleware(reducers);

  // TODO remove this! This IE is temporary til IE is sunset
  if (!isBrowserIE() && !isStaticRender()) {
    createProfile().then(({ profile }) => {
      Promise.resolve(getUserData(store, profile)).then(() => {
        renderPage(store);
      });
    });
  } else {
    Promise.resolve(getUserData(store)).then(accessToken => {
      if (!window.staticRender) {
        renderPage(store);
      } else {
        renderPageWithDataFetch(store, accessToken);
      }
    });
  }
}
